jQuery(document).ready(function($) {
  let autofill,
      autofill_for_shipping,
      place;

  function initAutocomplete() {
    if ( $('#shipping_address_1').length > 0 ) {
      autofill_for_shipping = new google.maps.places.Autocomplete(document.getElementById('shipping_address_1'));

      autofill_for_shipping.addListener('place_changed', fillInShippingAddress);
    }

    autofill = new google.maps.places.Autocomplete(document.getElementById('billing_address_1'));

    autofill.addListener('place_changed', fillInBillingAddress);
  }

  function fillInShippingAddress() {
    place = autofill_for_shipping.getPlace();

    $('#shipping_postcode').val('');
    $('#shipping_address_1').val('');
    $('#shipping_address_2').val('');
    $('#shipping_city').val('');

    for (let i = 0; i < place.address_components.length; i++) {
      let addressType = place.address_components[i].types[0];

      if (addressType == 'country') {
        $('#shipping_country').val(place.address_components[i]['short_name']);
        $('#shipping_country').trigger('change');
      }

      if (addressType == 'street_number') {
        $('#shipping_address_2').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'route') {
        $('#shipping_address_1').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'administrative_area_level_1') {
        let state = place.address_components[i]['short_name'];
        setTimeout(function() {
          $('#shipping_state').val(state);
          $('#shipping_state').trigger('change');
        },1500);
      }

      if (addressType == 'neighborhood') {
        $('#shipping_address_2').val(place.address_components[i]['long_name']);
      } else if (addressType == 'sublocality_level_3') {
        $('#shipping_address_2').val(place.address_components[i]['long_name']);
      } else if (addressType == 'sublocality_level_2') {
        $('#shipping_address_2').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'locality') {
        $('#shipping_city').val(place.address_components[i]['long_name']);
      }
      
      if (addressType == 'postal_code') {
        $('#shipping_postcode').val(place.address_components[i]['long_name']);
      }
    }
  }
  
  function fillInBillingAddress() {
    place = autofill.getPlace();
    $('#billing_postcode').val('');
    $('#billing_address_2').val('');
    $('#billing_address_1').val('');
    $('#billing_city').val('');

    for (let i = 0; i < place.address_components.length; i++) {
      let addressType = place.address_components[i].types[0];

      if (addressType == 'country') {
        $('#billing_country').val(place.address_components[i]['short_name']);
        $('#billing_country').trigger('change');
      }

      if (addressType == 'street_number') {
        $('#billing_address_2').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'route') {
        $('#billing_address_1').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'administrative_area_level_1') {
        let state = place.address_components[i]['short_name'];
        setTimeout(function() {
          $('#billing_state').val(state);
          $('#billing_state').trigger('change');
        },1500);
      }

      if (addressType == 'neighborhood') {
        $('#billing_address_2').val(place.address_components[i]['long_name']);
      } else if (addressType == 'sublocality_level_3') {
        $('#billing_address_2').val(place.address_components[i]['long_name']);
      } else if (addressType == 'sublocality_level_2') {
        $('#billing_address_2').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'locality') {
        $('#billing_city').val(place.address_components[i]['long_name']);
      }

      if (addressType == 'postal_code') {
        $('#billing_postcode').val(place.address_components[i]['long_name']);
      }

    }

  }

  if ($('#billing_address_1').length > 0) {
    initAutocomplete();
  }
});
